import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

const PaginationComponent = ({ activePage, pageCount, onPageChange }) => {
    // Safety checks
    if (!pageCount || pageCount <= 0 || !activePage || activePage <= 0) {
        return null;
    }

    const getVisiblePages = () => {
        if (pageCount <= 7) {
            // If total pages <= 7, show all pages
            return Array.from({ length: pageCount }, (_, i) => i + 1);
        }

        const delta = 2; // Number of pages to show on each side of active page
        const rangeWithDots = [];

        // Always show first page
        rangeWithDots.push(1);

        // Calculate start and end of visible range
        const start = Math.max(2, activePage - delta);
        const end = Math.min(pageCount - 1, activePage + delta);

        // Add ellipsis if there's a gap after page 1
        if (start > 2) {
            rangeWithDots.push('...');
        }

        // Add visible page numbers
        for (let i = start; i <= end; i++) {
            rangeWithDots.push(i);
        }

        // Add ellipsis if there's a gap before last page
        if (end < pageCount - 1) {
            rangeWithDots.push('...');
        }

        // Always show last page if it's not already included
        if (pageCount > 1 && !rangeWithDots.includes(pageCount)) {
            rangeWithDots.push(pageCount);
        }

        return rangeWithDots;
    };

    const visiblePages = getVisiblePages();

    // Don't render pagination if there's only one page or no pages
    if (pageCount <= 1) {
        return null;
    }

    return (
        <div className="">
            <Pagination className="flex-wrap justify-content-center">
                <Pagination.Prev 
                    onClick={() => onPageChange(Math.max(1, activePage - 1))} 
                    disabled={activePage === 1} 
                />
                
                {visiblePages.map((page, index) => (
                    page === '...' ? (
                        <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
                    ) : (
                        <Pagination.Item
                            key={page}
                            active={page === activePage}
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </Pagination.Item>
                    )
                ))}
                
                <Pagination.Next 
                    onClick={() => onPageChange(Math.min(pageCount, activePage + 1))} 
                    disabled={activePage === pageCount} 
                />
            </Pagination>
        </div>
    );
};

export default PaginationComponent;
